import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { Card } from './internal/components/Card';
import { JKImage } from './internal/components/JKImage';

import styles from './PikInNumbers.css';

type TPikInNumbersProps = {
  onView: () => void;
};

export const PikInNumbers: FC<TPikInNumbersProps> = ({ onView }) => {
  return (
    <LayoutBlock id="pik-in-numbers" title="ПИК в цифрах" onView={onView}>
      <div className={styles['container']}>
        <div className={styles['card']}>
          <Card
            description={
              <>
                в 14 регионах РФ сейчас
                <br />в реализации ПИК
              </>
            }
            image={<JKImage />}
            theme="orange"
            title=">150 жилых кварталов"
          />
        </div>
        <div className={styles['card']}>
          <Card description="жилья уже застроили" title="37 млн м²" />
        </div>
        <div className={styles['card']}>
          <Card description="семей проживает в кварталах ПИК" title=">620 тыс. семей" />
        </div>
        <div className={styles['card']}>
          <Card
            description={
              <>
                социнфраструктуры уже построено ПИК:
                <br />
                106 детсадов, 44 школы, 20 поликлиник
              </>
            }
            title=">170 объектов"
          />
        </div>
        <div className={styles['card']}>
          <Card
            description={
              <>
                человек работает
                <br />
                над проектами ПИК
              </>
            }
            title=">30 тысяч"
          />
        </div>
      </div>
    </LayoutBlock>
  );
};
